// apps/web/src/features/call-center/components/CallCenterNewLeadDrawer.tsx
//
// New-lead `EditorDrawer` for the external agent (#1398). Hosts the reusable
// `<CallCenterLeadForm>`; the form's `isDirty` drives the drawer's
// unsaved-changes guard. On submit success the parent toasts, closes, and
// invalidates the my-leads key (the submit hook also invalidates). On an
// own-history collision (#1397) the form renders a localized inline error and
// the drawer STAYS open.
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { EditorDrawer, DetailSheet, useEditorGuard } from '../../../ui/index.js';
import { CallCenterLeadForm } from '../CallCenterLeadForm.js';

export function CallCenterNewLeadDrawer({
  narrow,
  onClose,
  onSubmitted,
}: {
  narrow: boolean;
  onClose: () => void;
  onSubmitted: () => void;
}) {
  const [dirty, setDirty] = useState(false);
  return (
    <EditorDrawer width={520} narrow={narrow} dirty={dirty} onConfirmClose={onClose}>
      <NewLeadBody onClose={onClose} onSubmitted={onSubmitted} onDirtyChange={setDirty} />
    </EditorDrawer>
  );
}

function NewLeadBody({
  onClose,
  onSubmitted,
  onDirtyChange,
}: {
  onClose: () => void;
  onSubmitted: () => void;
  onDirtyChange: (dirty: boolean) => void;
}) {
  const { t } = useTranslation('callCenter');
  // WHY: route the DetailSheet back button through the shared guard so a
  //   dirty form surfaces the discard prompt (the EditorDrawer wires the same
  //   guard for Escape/backdrop).
  const { confirmDestructive } = useEditorGuard();
  return (
    <DetailSheet
      title={t('selfService.newLeadDrawer.title')}
      onClose={() => confirmDestructive(onClose)}
    >
      <CallCenterLeadForm onDirtyChange={onDirtyChange} onSubmitted={onSubmitted} />
    </DetailSheet>
  );
}
